/**
 * Blog Post Content
 *
 * Renders MDX article content with TLDR section and proper Figma design styling
 */
'use client';

import React from 'react';
import { Post } from '@/types/post';

interface BlogPostContentProps {
  post: Post;
  children: React.ReactNode;
}

export default function BlogPostContent({ post, children }: BlogPostContentProps) {
  return (
    <div className="max-w-5xl">
      {/* TLDR Section */}
      {post.tldr && (
        <div className="mb-16 border-l-4 border-androia-blue bg-androia-blue/5 p-8 rounded-r-lg">
          <h2 className="text-3xl font-bold text-androia-blue font-manrope mb-6">TL;DR</h2>
          <p className="text-xl text-androia-gray-600 leading-relaxed font-manrope">{post.tldr}</p>
        </div>
      )}

      {/* Article Content - MDX Rendered with Figma Design Styling */}
      <article className="prose-custom max-w-none">{children}</article>
    </div>
  );
}
